import styled from '@emotion/styled'
import {theme} from '../../../theme'

// border matches LocationDetailPanel's (the Thryv Kickoff Call / Thryv
// Success Services Call panel below it — see SchedulingStep.styles.js) so
// both cards in this column read as the same bordered style.
export const OnboardingContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[3]};
  height: 100%;
  background: ${theme.colors.bg.primary};
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.lg2};
  padding: ${theme.space[4]};
`

export const OnboardingContactHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${theme.space[3]};
`

export const OnboardingContactTitle = styled.span`
  font-size: ${theme.fontSizes.base};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
`

export const OnboardingContactCheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text.primary};
  cursor: pointer;
  width: fit-content;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    flex-shrink: 0;
  }
`

// The two sub-columns: [First/Last Name] and [Email/Phone].
export const OnboardingContactFieldsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.space[3]};

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const OnboardingContactColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[3]};
`
